import { AppServerAPI } from '@sdbn/common';
import { Component, OnInit, Inject } from '@angular/core';
import { ResponseMessage } from '@sdbn/common';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslationService } from '@sdbn/common';
import { ServiceResponse } from '@sdbn/common';

import { ResponseStatus } from '@sdbn/common';
import { TMCClientParameters } from '@sdbn/tmc-common';
import { AppClientConfigurationService } from '@sdbn/common';
import { TransportStationAssignment, BeginUmbrueckung, UmbrueckungDetails } from '../../model/sac-client.model';
import { TransportScope } from '../../../../../common/model/transport.model';

@Component({
  selector: 'app-sac-begin-umbrueckung-dialog',
  templateUrl: './sac-begin-umbrueckung-dialog.component.html',
  styleUrls: ['./sac-begin-umbrueckung-dialog.component.scss']
})
export class SacBeginUmbrueckungDialogComponent implements OnInit {

  sourceTransportAssignment: TransportStationAssignment;
  targetTransportAssignment: TransportStationAssignment;

  details = new UmbrueckungDetails({});

  responseMessages: ResponseMessage[];
  isLoading = false;

  umbrueckungPossible = false;

  constructor(
    public configurationService: AppClientConfigurationService,
    public dialogRef: MatDialogRef<SacBeginUmbrueckungDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private appServerAPI: AppServerAPI,
    public translationService: TranslationService
  ) {
    this.sourceTransportAssignment = data.sourceTransportAssignment;
    this.targetTransportAssignment = data.targetTransportAssignment;
  }

  ngOnInit() {

    this.appServerAPI.execute<UmbrueckungDetails>('/client/control/sac-client',
      [this.sourceTransportAssignment, this.targetTransportAssignment]).subscribe(
        details => {
          if (details.status !== ResponseStatus.SUCCESS) {
            this.responseMessages = details.responseMessages;
            this.umbrueckungPossible = false;
          } else {
            this.details = new UmbrueckungDetails(details);
            this.umbrueckungPossible = true;
          }
        }
      );
  }

  public isCloseDialogDisabled() {
    return false;
  }

  public closeDialog() {
    this.dialogRef.close();
  }

  public beginUmbrueckung() {

    const request = new BeginUmbrueckung();
    request.sourceTransport = { id: this.sourceTransportAssignment.transport.id };
    request.sourceTransportStationId = { id: this.sourceTransportAssignment.station.id };

    request.targetTransport = { id: this.targetTransportAssignment.transport.id };
    request.targetTransportStationId = { id: this.targetTransportAssignment.station.id };

    request.swapTrailerNumber = this.details.swapTrailerNumber;
    request.trailerNumberPlate = this.details.trailerNumberPlate;

    this.appServerAPI.execute<ServiceResponse>('/client/control/sac-client/begin-umbrueckung', request).subscribe(
      response => {
        if (response.status !== ResponseStatus.SUCCESS) {
          this.responseMessages = response.responseMessages;
        } else {
          this.dialogRef.close();
        }
      },
      error => {
        console.log('Unexpexted Error: ', error);
      }
    );
  }

  public isBeginUmbrueckungDisabled() {

    if (!this.umbrueckungPossible) {
      return true;
    }

    if (this.isTrailerNumberPlateRequired()
      && (this.details.trailerNumberPlate == null || this.details.trailerNumberPlate.length === 0)) {
      return true;
    }

    if (this.isSwapTrailerNumberRequired()
      && (this.details.swapTrailerNumber == null || this.details.swapTrailerNumber.length === 0)) {
      return true;
    }

  }

  public isTrailerNumberPlateRequired(): boolean {
    return this.details.targetTransportScope === TransportScope.TRAILER;
  }

  public isTrailerNumberVisible(): boolean {
    return this.details.targetTransportScope === TransportScope.TRAILER;
  }

  public isSwapTrailerNumberRequired(): boolean {
    if (this.isSwapTrailerEnabled()) {
      return this.details.targetTransportScope === TransportScope.SWAP_TRAILER;
    }
    return false;
  }

  public isSwapTrailerEnabled(): boolean {
    return this.configurationService.isPropertyTrue(TMCClientParameters.P_VISITS_ATTACH_DETACH_SWAP_TRAILER_ENABLED, false);
  }

}

